import React from 'react';
import { Card } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.css';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { compose } from 'redux';
import { Route, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import NavbarNew from '../../components/NavBarNew/NavbarNew';
import { getCookies } from '../../utils/getToken';
import Axios from 'axios';
import { SERVER_URL } from '../../utils/config/constants';


const styles = theme => ({
    heading: {
        color: '#ffffff'
    },
    paper: {
        backgroundColor: theme.palette.primary.main
    },
    card: {
        color: theme.palette.secondary.main
    }
});
let isLoading = true;
class ProviderManageTodaysBookingsNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            activeTab: 'Requested',
            isRequestedActive: true,
            isConfirmedActive: false,
            isCompletedActive: false,
            requestedData: [],
            confirmedData: [],
            completedData: [],

            todaysBookingData: [],
        };
    }
    componentDidMount() {
        this.getTodaysBookingData()
        this.changeTab();
    }

    getTodaysBookingData = async (key) => {
        var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/today-booking`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('todays pro data', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: false,
                    todaysBookingData: data.data, 
                })
            }
            else {
                this.setState({
                    loading: false
                })
            }
        } catch (error) {
            console.log("====================todays list ERRORRRRRR", error);
        }
    }

    changeTab = async () => {
        // let activeopen = this.props.history.location.state.tab
        let activeopen = this.state.activeTab

        // let activeopen;
        // if(this.props.history.location.state.tab){
        //     activeopen = this.props.history.location.state.tab
        // } else {
        //     activeopen = 'Requested'
        // }
        console.log('chekingtab....................', activeopen)
        if (activeopen) {
            if (activeopen === "Requested") {
                console.log('working...........1')
                this.setState({
                    isRequestedActive: true,
                    isConfirmedActive: false,
                    isCompletedActive: false,
                    activeTab: 'Requested'
                })
            }
            else if (activeopen === "Confirmed") {
                console.log('working...........2')
                this.setState({
                    isRequestedActive: false,
                    isConfirmedActive: true,
                    isCompletedActive: false,
                    activeTab: 'Confirmed'
                })
            } else {
                console.log('working...........3')
                this.setState({
                    isRequestedActive: false,
                    isConfirmedActive: false,
                    isCompletedActive: true,
                    activeTab: 'Completed'
                })
            }
        }

    }

    onTabPress = (tab) => {
        this.getBookingSummaryData()
        if (tab === "Requested") {
            console.log("REQ", tab);
            this.setState({
                isRequestedActive: true,
                isConfirmedActive: false,
                isCompletedActive: false,
                activeTab: 'Requested'

            })
        } else if (tab === "Confirmed") {
            console.log("CONFIMED", tab);
            this.setState({
                isRequestedActive: false,
                isConfirmedActive: true,
                isCompletedActive: false,
                activeTab: 'Confirmed'
            })
        } else {
            console.log("COMPLETED", tab);
            this.setState({
                isRequestedActive: false,
                isConfirmedActive: false,
                isCompletedActive: true,
                activeTab: 'Completed'
            })
        }
    }

    renderManageBookingList = (booking) => {
        // console.log("------- ============= statuuuussss BOOKING LIST ITEM", booking);
        var monthNames = [ "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December" ];
    
        let originalDate = booking.booking_details.booking_date;
        let year = originalDate.substring(0,4)
        let month = ( Number(originalDate.substring(5,7)) - 1 );
        let date = originalDate.substring(8,10)
        let formattedDate = monthNames[month] + ' ' + date + ', ' + year;

        return (
            <div key={booking.id}>
                {/* <p>{item.booking_details.booking_number}</p> */}

                <div style={{
                backgroundColor: '#ddd',
                marginBottom: 20,
                boxShadow: "1px 1px 20px #ddd",
                backgroundColor: '#fff',
                padding: 20,
                borderRadius: '10px'
            }}>
                <div
                
                style={{
                    display:'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div
                       
                    style={{
                    display:'flex',
                    alignItems: 'center'
                }}>
                        <img src={booking.taskData.image.medium} style={{height: '5rem', width: '5rem', borderRadius: 5}} />
                        <div style={{
                            marginLeft: 15
                        }}>
                            <p style={{
                                color: '#0078ff',
                                fontSize: 22,
                                fontWeight: 'bold',
                                marginBottom:0
                            }}>{booking.taskData.full_name.service}</p>
                            <p style={{
                                // color: 'green',
                                fontSize: 18,
                                marginBottom:0
                            }}>Booking# {booking.booking_details.booking_number}</p>
                        </div>
                    </div>
                    {
                        booking.status === 'rescheduled-user' &&
                        <div 
                      
                        style={{
                            marginTop: '-4rem'
                        }}>
                            <p style={{
                                color: 'orange',
                                fontSize: 18,
                                fontWeight: 'bold'
                            }}>Rescheduled by User</p>
                        </div>
                    }
                    {
                        booking.status === 'rescheduled-provider' &&
                        <div style={{
                            marginTop: '-4rem'
                        }}>
                            <p style={{
                                color: 'orange',
                                fontSize: 18,
                                fontWeight: 'bold'
                            }}>Rescheduled by You</p>
                        </div>
                    }
                    {
                        booking.status === 'closed' &&
                        <div style={{
                            marginTop: '-4rem'
                        }}>
                            <p style={{
                                color: 'green',
                                fontSize: 18,
                                fontWeight: 'bold'
                            }}>Completed</p>
                        </div>
                    }
                    {
                        booking.status === 'denied-confirmed' &&
                        <div style={{
                            marginTop: '-4rem'
                        }}>
                            <p style={{
                                color: 'red',
                                fontSize: 18,
                                fontWeight: 'bold'
                            }}>Denied</p>
                        </div>
                    }
                    {
                        (booking.status === 'completed' || booking.status === 'denied') &&
                        <div style={{
                            marginTop: '-4rem'
                        }}>
                            <p style={{
                                color: 'orange',
                                fontSize: 18,
                                fontWeight: 'bold'
                            }}>Pending Approval</p>
                        </div>
                    }
                    {
                        booking.status === 'revised-price' &&
                        <div
                        
                        style={{
                            marginTop: '-4rem'
                        }}>
                            <p style={{
                                color: 'orange',
                                fontSize: 18,
                                fontWeight: 'bold'
                            }}>Revised Price</p>
                        </div>
                    }
                </div>
                <div style={{
                            marginLeft: 20,
                            marginTop: 15
                        }}>
                    <p
                        id='task_description'
                        style={{
                            fontSize: 18,
                        }}
                    >Task Description: {booking.taskData.description
                        ? booking.taskData.description
                        : 'No Description found'}
                    </p>
                    <div 
                        style={{
                        display:'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div>
                            <p
                                style={{
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    marginBottom:0
                                }}
                            >Location: {booking.booking_details.address_city}</p>
                            <p
                                style={{
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    marginBottom:0
                                }}
                            >Schedule Date: {" "}
                            {formattedDate}
                            </p>
                        </div>
                        <p style={{
                            backgroundColor: '#0078ff',
                            padding: '15px 20px',
                            padding: '10px 25px',
                            borderRadius: 50,
                            color: 'white',
                            marginBottom: 0,
                            fontSize: 17,
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                        // onClick={()=> this.onDetailsPressed(booking)}
                        onClick={()=> this.props.history.push(`/provider/booking_today/:id/${booking.id}`, 
                            { bookingDetailsData: booking }
                        )
                        }
                        >Details</p>
                    </div>
                </div>
            </div>

                {/* <div
                    style={
                        {
                            width: '95%',
                            alignSelf: 'center',
                            borderRadius: 10,
                            marginBottom: 10,
                            elevation: 10,
                            position: 'relative'
                        }
                    }
                >
                    {
                        item.status === "rescheduled-user" &&
                        <p
                            style={{
                                marginTop: 10,
                                fontWeight: "800",
                                color: "orange",
                                position: 'absolute',
                                top: 5,
                                right: 15,
                                width: '25%',
                                pAlign: 'center'
                            }} >
                            Rescheduled by User
                        </p>
                    }

                    {
                        item.status === "rescheduled-provider" &&
                        <p
                            style={{
                                marginTop: 10,
                                fontWeight: "800",
                                color: "orange",
                                position: 'absolute',
                                top: 5,
                                right: 15,
                                width: '25%',
                                pAlign: 'center'
                            }} >
                            Rescheduled by You
                        </p>
                    }

                    {
                        item.status === "closed" &&
                        <p
                            style={{
                                marginTop: 10,
                                fontWeight: "800",
                                color: "green",
                                position: 'absolute',
                                top: 10,
                                right: 20
                            }} >
                            Completed
                        </p>
                    }


                    {
                        item.status === "denied-confirmed" &&
                        <p
                            style={{
                                marginTop: 10,
                                fontWeight: "800",
                                color: "red",
                                position: 'absolute',
                                top: 10,
                                right: 20
                            }} >
                            Denied
                        </p>
                    }

                    {
                        (item.status === "completed" || item.status === "denied") &&
                        <p
                            style={{
                                marginTop: 10,
                                fontWeight: "800",
                                color: "orange",
                                position: 'absolute',
                                top: 5,
                                right: 10,
                                width: '25%',
                                pAlign: 'center'
                            }} >
                            Pending Approval
                        </p>

                    }

                    {
                        item.status === "revised-price" &&
                        <p
                            style={{
                                marginTop: 10,
                                fontWeight: "800",
                                color: "orange",
                                position: 'absolute',
                                top: 5,
                                right: 10,
                                width: '20%',
                                pAlign: 'center'
                            }} >
                            Revised Price
                        </p>

                    }

                    <div
                        activeOpacity={0.8}
                        style={{
                            padding: 10,
                            justifyContent: 'space-between',
                        }}
                    >
                        <div style={{
                            flex: 1,
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <div style={{
                                height: 50, width: 50, backgroundColor: "#eee",
                                borderRadius: 5,
                                justifyContent: "center", alignContent: "center", alignItems: "center"
                            }}>
                                <img
                                    src={item.taskData.image.medium}
                                    alt={`task-${item.taskData.image.medium}`}
                                    style={{
                                        width: 120,
                                        height: 120,
                                        borderRadius: 5
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    flexDirection: "row",
                                    marginLeft: 13,
                                    justifyContent: 'space-between',
                                    minWidth: '80%',
                                    maxWidth: '80%'
                                }}>
                                <div>
                                    <p
                                        numberOfLines={1} style={{ maxWidth: '100%', fontSize: 17, fontWeight: '700', color: "#0078FF" }}>
                                        {item.taskData.full_name.service}
                                    </p>
                                    <p
                                        numberOfLines={2} style={{ maxWidth: '100%', fontSize: 13, color: "grey", color: 'green' }}>
                                        Booking# {item.booking_details.booking_number}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginLeft: 10, marginTop: 10 }}>
                            <p
                                style={{
                                    fontSize: 18,
                                    color: "grey",
                                    marginTop: 10,
                                    marginRight: 10
                                }}>
                                Task description:{" "}
                                {item.taskData.description
                                    ? item.taskData.description
                                    : 'No Description found'}
                            </p>
                        </div>
                        <div style={{ flexDirection: 'row', marginTop: 10, marginLeft: 10, marginRight: 10, justifyContent: 'space-between', alignItems: 'center', paddingBottom: 10 }}>
                            <div>
                                <p
                                    numberOfLines={2} style={{ maxWidth: '100%', fontSize: 18, color: "grey", fontWeight: '700' }}>
                                    Location: {item.booking_details.address_city}
                                </p>
                                <p
                                    numberOfLines={2} style={{ maxWidth: '100%', fontSize: 18, color: "grey", fontWeight: '700' }}>
                                    Scheduled Date:
                                </p>
                            </div>
                            <div
                            >
                                <div>
                                    <p style={{ backgroundColor: 'orange', padding: 5, paddingHorizontal: 15, borderRadius: 50, fontWeight: '700', color: 'white' }}>
                                        Details
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }

    render() {
        const { classes } = this.props;
        const {
            providerData,
            weeklyData,
            monthlyData,
            yearlyData
        } = this.state;

        var bookingStatusLength = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid #0078ff',
            borderRadius: '5px',
            padding: 20
        }
        return (
            <div className="tz-2-com tz-2-main">
                <NavbarNew
                    title={`Today's Bookings`}
                    goback={() => this.props.history.goBack(null)}
                />
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // marginTop: -40,
                    }}>
                        <div>
                            {
                                this.state.todaysBookingData
                                    .sort((a, b) => {
                                        return new Date(a.booking_details.booking_start_datetime).getTime() - new Date(b.booking_details.booking_start_datetime).getTime()
                                        // // return b.booking_start_datetime - a.booking_start_datetime
                                    })
                                    .map((i) => {
                                        return this.renderManageBookingList(i)
                                    })
                            }
                            
                            {
                                 this.state.todaysBookingData.length === 0
                                    ?
                                    <div style={{
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginTop: 20
                                    }}>
                                        <p style={{
                                            fontSize: 18
                                        }}>No bookings founds</p>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = ({ settings }) => {
//     return {
//         colors: settings.colors
//     };
// };
const composedComponent = compose(
    withStyles(styles),
    withTheme(),
    connect(
        null,
        actions
    )
);

export default withRouter(composedComponent(ProviderManageTodaysBookingsNew));



// WEBPACK FOOTER //
// ./src/views/ProviderScreensNew/ProviderManageTodaysBookingsNew.jsx